import React from 'react'

export default function Footer() {
  return (
    <div className='pt-[100px] flex items-center justify-between pl-4 pr-4'>
        <div></div>
        <p className='footer-text text-center text-white'>Made with ❤️ from 🇩🇪</p>
    </div>
  )
}
